
import {level_arr} from './variables';
import _ from 'lodash';
import {Employee_level_url} from './variables';
export function getLevel(selected){
    let keys = level_arr;
    for(let i = 0;i < keys.length - 1;i++){
        if(_.isEmpty(selected[keys[i]]) || _.isUndefined(selected[keys[i]]) || _.isNull(selected[keys[i]])){
            return keys[i];
        }
    }
    return keys[keys.length - 1];
}

export function getPreLevel(level){
    let prevLevelIndex = _.findIndex(level_arr,(e)=>{return e === level}) - 1;
    let prevLevel = level_arr[prevLevelIndex > -1 ? prevLevelIndex : 0];
    return prevLevel;
}

export function getNextLevel(level){
    let nextLevelIndex = _.findIndex(level_arr,(e)=>{return e === level}) + 1;
    let nextLevel = level_arr[nextLevelIndex < level_arr.length ? nextLevelIndex : level_arr.length - 1];
    return nextLevel;
}

export async function postData(url = '', data = {}) {
    // Default options are marked with *
    let Token=localStorage.getItem('token')
    console.log(Token);
    const response = await fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        "x-access-token":Token,
        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Frame-Options': 'DENY',
                        'Content-Security-Policy': "frame-ancestors 'none'",
                        'Feature-Policy': "frame-ancestors 'none'"
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    });
    return response.json(); // parses JSON response into native JavaScript objects
  }

  
  export function getAccessibleState(optionSelection)
  {
    //console.log(optionSelection);
    let data = JSON.parse(localStorage.getItem('userInfo'));
    // console.log('access state',optionSelection);
    //return 'ALL';
    let flag = false;

    if(data['level']==='HO'||optionSelection.level === 'HO'){
        // console.log('access state',optionSelection.option,"level ", optionSelection.level);
        if(optionSelection.level === 'zo' || optionSelection.level === 'Zone' ){
            // console.log('access state',optionSelection.option,"level ", optionSelection.level);
            return _.uniq(_.flattenDeep(data['AccessIn'].map((item)=>{
                // console.log(optionSelection.option ," ---- " ,  item.Zone);
                if(optionSelection.option === item?.Zone){
                    return item?.State;
                }
            })))

        }
        if(optionSelection.level === 'ro'|| optionSelection.level === 'Region'){
            // console.log('access state',optionSelection.option,"level ", optionSelection.level);
            return _.uniq(_.flattenDeep(data['AccessIn'].map((item)=>{
                // console.log(optionSelection.option ," ---- " ,  item.Region);
                if(optionSelection.option === item?.Region){
                    return item?.State;
                }
            })))

        }

        
        // return _.uniq(_.flattenDeep(data['AccessIn'].map((item)=>{
        //     return item.State
        // })))
        //     return _.uniq(_.flattenDeep(data['AccessIn'].map((item)=>{
        //         // return item.Region.map((res)=>{
        //         //     console.log(res);
        //         // })
        //         console.log("from zo",item.Region);
        //     })))
        return 'ALL';
        //code kro
        flag = true;
    }
    if(flag === true){
        
        //zo dealer ka ho ka obj ke liye likhna hai
    }
    else{
        if(optionSelection.level === 'zo' || optionSelection.level === 'Zone' )
        return _.uniq(_.flattenDeep(data['AccessIn'].map((item)=>{
            return item.State
        })))
        else if(optionSelection.level === 'ro'|| optionSelection.level === 'Region'){
            if(!optionSelection.option) return getAccessibleState({'level':'zo'});
            

        return _.uniq(_.flattenDeep(data['AccessIn'].map((item)=>{
            if(optionSelection.option === item.Region)
                return item.State
            else if(optionSelection.option === 'ALL')
                return item.State
        })))
    }
    else if(optionSelection.level === 'dealer' || optionSelection.level === 'Dealer'){
        if(optionSelection.option === 'ALL'){
            // return data['AccessIn'].map((item)=>{
            //     return item.State[0]
            // })
            return _.uniq(_.flattenDeep(data['AccessIn'].map((item)=>{
                return item.State
            })))
    }
    else{
        if(!optionSelection.option) return getAccessibleState({'level':'ro','option' : optionSelection.prevOption});
        return _.uniq(_.flattenDeep(optionSelection?.dealers.filter((item)=>{
            return (item.Dealer === optionSelection.option)
        }).map((item)=>{
            return item.State
        })))
    }
    }
    }
  }